
import { postBulkSignature } from '@/api';
import Button from '@/components/UI/button/Button.vue';
import { User } from '@/models/main';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {
    Button,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class BulkReports extends Vue {
  private user!: User;
  private message = '';
  private errorMessage = '';
  private isValid = true;
  private isLoading = false;
  private sendRequest(): void {
    this.errorMessage = '';
    this.isValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
    if (this.isValid) {
      this.isLoading = true;
      const messageJson = {
        refs: this.message.split('\n'),
      };
      const fileName: string = this.message.replace('\n', '-').substring(0, 29);
      postBulkSignature(messageJson)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/zip' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href);
          this.isLoading = false;
        })
        .catch(e => {
          if (e.response.status === 404) {
            this.errorMessage = 'It seems that there is no job with this RH number';
            this.isValid = false;
            this.isLoading = false;
            return null;
          }
          this.errorMessage = 'Something went wrong';
          this.isLoading = false;
        });
    }
  }
  private mounted(): void {
    if (!this.user.staff) {
      this.$router.push({ path: '/dash' });
    }
  }
}
